import { Directive, Output, EventEmitter, ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { OutsideEventDirective } from './outside-event.directive';

@Directive({
  selector: '[wfmOutsideMousedown]'
})
export class OutsideMousedownDirective extends OutsideEventDirective {
  @Output() wfmOutsideMousedown: EventEmitter<any>;

  constructor(@Inject(DOCUMENT) document, element: ElementRef) {
    super(document, element, 'mousedown');
    this.wfmOutsideMousedown = this.wfmOutsideEvent;
  }
}
